import React, { useState, useEffect } from 'react';
import './ImageSlider.css'; 

const images = [
  '/Assets/10.jpg',
  '/Assets/10.jpg',
  '/Assets/10.jpg',
  '/Assets/1.jpeg',
  '/Assets/2.jpeg',
  '/Assets/3.jpeg',
  '/Assets/5.jpeg',
  '/Assets/7.jpeg',
  '/Assets/8.jpeg',
  '/Assets/13.jpg',
  '/Assets/14.jpg',
  '/Assets/20.jpg',
  '/Assets/15.jpg',
  '/Assets/32.avif',
  '/Assets/33.webp',
  '/Assets/31.jpg',
  '/Assets/34.jpg',
  '/Assets/11.jpeg',
  '/Assets/12.jpeg',
];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = React.useRef(null);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    intervalRef.current = setInterval(nextImage, 3000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const handleNextClick = () => {
    clearInterval(intervalRef.current);
    nextImage();
    intervalRef.current = setInterval(nextImage, 5000);
  };

  const handlePrevClick = () => {
    clearInterval(intervalRef.current);
    prevImage();
    intervalRef.current = setInterval(nextImage, 5000);
  };

  return (
    <div className="slider-container">
      <div className="image-slider">
        <div className="image-container">
          <img src={images[currentIndex]} alt={`Image ${currentIndex + 1}`} className="slider-image" />
          <div className="overlay">
            <div className='overlay-container'>
            <h1 className='Welcome_text'>Welcome To <br/> Moonside Rooms</h1>
            <p className="overlay-text">a comfortable 2-star accommodation/self-check-in in the heart of Lincolnshire, ideally located just 400 yards from Winthorpe Beach and 400 yards from the famous Skegness Butlins.</p>
            <div id='buttons'>
            <a href='/reserving'><button id='booking'>Book Now</button></a>
            <a href='#select-room'><button id='learn'>Learn More</button></a>
            </div>
            </div>
          </div>
        </div>
      </div>

      <button className="next-button slider-button" onClick={handleNextClick}>Next</button>
    </div>
  );
};

export default ImageSlider;
